import { render, staticRenderFns } from "./AppSelect.vue?vue&type=template&id=1f4014b8&scoped=true&"
import script from "./AppSelect.vue?vue&type=script&lang=js&"
export * from "./AppSelect.vue?vue&type=script&lang=js&"
import style0 from "./AppSelect.vue?vue&type=style&index=0&id=1f4014b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4014b8",
  null
  
)

export default component.exports